import React from 'react'
import { MeasurementsFormData } from '../../models/measurements'
import { Box, Stack, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import LabeledFieldDisplay from 'src/Libs/installation-statement/components/Overview/LabeledFieldDisplay'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'

interface Props {
  data: MeasurementsFormData
}

/**
 * Component to display the saved values of the measurement tab on the overview tab
 */
const Measurement: React.FC<Props> = ({ data }) => {
  const { t } = useCustomTranslation()

  return (
    <Stack spacing={2}>
      <Typography variant="h4">{t('installation-statement.measurement.title')}</Typography>
      <Typography variant="caption">{t('installation-statement.measurement.device.title')}</Typography>
      <Box>
        <LabeledFieldDisplay label={t('installation-statement.measurement.device.manufacturer')} dataField={data.measurementDeviceManufacturer} />
        <LabeledFieldDisplay label={t('installation-statement.measurement.device.type')} dataField={data.measurementDeviceType} />
      </Box>
      <Box>
        <Typography variant="subtitle2" sx={{ pb: 2 }}>
          {t('installation-statement.measurement.impedanceLoop.title')}
        </Typography>
        <LabeledFieldDisplay
          label={t('installation-statement.measurement.loopImpedanceNL1')}
          dataField={data.loopImpedanceNL1 ? getLocalizedNumber(Number(data.loopImpedanceNL1)) : null}
          isFieldOptional
        />
        <LabeledFieldDisplay
          label={t('installation-statement.measurement.loopImpedanceNL2')}
          dataField={data.loopImpedanceNL2 ? getLocalizedNumber(Number(data.loopImpedanceNL2)) : null}
          isFieldOptional
        />
        <LabeledFieldDisplay
          label={t('installation-statement.measurement.loopImpedanceNL3')}
          dataField={data.loopImpedanceNL3 ? getLocalizedNumber(Number(data.loopImpedanceNL3)) : null}
          isFieldOptional
        />
        <LabeledFieldDisplay
          label={t('installation-statement.measurement.loopImpedancePEL')}
          dataField={data.loopImpedancePEL ? getLocalizedNumber(Number(data.loopImpedancePEL)) : null}
          isFieldOptional
        />
      </Box>
    </Stack>
  )
}

export default Measurement
